module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1600.72a497f7.svg";